// extracted by mini-css-extract-plugin
export default {"links":"Products_links__2+qMn","container":"Products_container__w9-ee","header":"Products_header__uXyBU"};